import Seo from "@/components/Seo";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import About from "@/components/About";
import SocialMatrix from "@/components/SocialMatrix";
import { useLang } from "@/lib/i18n";

export default function AboutPage() {
  const { lang } = useLang();
  return (
    <div className="bg-[#050505] min-h-screen">
      <Seo
        title={lang === "zh" ? "关于夢工廠 — DFE 娛樂夢工廠" : "About — Dream Factory Entertainment"}
        description={lang === "zh" ? "娛樂夢工廠 DFE 于 2009 年在马来西亚创立，深耕台湾、香港、中国、东南亚及欧美市场的演唱会制作与艺人管理。" : "Dream Factory Entertainment — founded in Malaysia in 2009. Concert production, festivals and artist management across Asia and worldwide."}
      />
      <NavBar />
      <main className="pt-16">
        <About />
        <SocialMatrix />
      </main>
      <Footer />
    </div>
  );
}
